import { Component, forwardRef, Host, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import * as moment from 'moment';

import { DatepickerComponent } from '../datepicker';

import { environment } from '../../../../environments/environment';
import {Helper} from '../../classes/helpers';


@Component({
  selector: 'app-lockable-datepicker',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LockableDatepickerComponent),
      multi: true
    },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: environment.datePickerFormat,
        },
        display: {
          dateInput: environment.datePickerFormat,
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: environment.datePickerFormat,
          monthYearA11yLabel: 'MMMM YYYY',
        },
      }
    }
  ]
})
export class LockableDatepickerComponent extends DatepickerComponent {
  private lastValue: string;

  constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer
  ) {
    super(controlContainer);
  }

  onSlideToggleChange(result: boolean): void {
    if (result) {
      if (this.datepickerInputRef) {
        this.lastValue = this.datepickerInputRef.nativeElement.value;
      }

      this.resetDatepicker();
    }
    else {
      const isoDate = this.lastValue;

      if (this.onChange) {
        this.onChange(isoDate);
      }

      this.writeValue(isoDate);
    }

    if (this.control) {
      this.control.disabled = result;
    }
  }

  getTexts(): [string, string] {
    if (
      this.control &&
      this.control.more &&
      this.control.more.hasOwnProperty('texts') &&
      Array.isArray(this.control.more.texts) &&
      this.control.more.texts.length === 2
    ) {
      return [this.control.more.texts[0], this.control.more.texts[1]];
    }

    return ['', ''];
  }
}
